import { Card, Chip } from '@nextui-org/react'
import { FC } from 'react'
import { useShallow } from 'zustand/react/shallow'
import searchIcon from '../../assets/icons/searchIcon.png'
import useChartStore from '../../store/chart/useChartStore'

type SelectTanksBrowserOpenProps = {
  onOpen: () => void
}

export const SelectTanksBrowserOpen: FC<SelectTanksBrowserOpenProps> = ({ onOpen }) => {
  const { schools, groupName } = useChartStore(
    useShallow((state) => ({
      schools: state.schools,
      groupName: state.groupName,
    })),
  )
  return (
    <Card
      className="flex flex-row w-full items-center gap-2 md:gap-3 p-2 md:p-[10px] border border-tdpldarkgrey border-opacity-60"
      radius="md"
      shadow="sm"
      isPressable
      onPress={onOpen}
      data-test="select-tanks-trigger"
    >
      <img
        src={searchIcon}
        alt="Search"
        className="w-6 h-6 md:w-8 md:h-8 flex-shrink-0 object-contain"
      />
      {schools.length === 0 ? (
        <div className="flex-grow text-center text-sm md:text-base text-tdpllightgrey">
          Click here to select tanks to browse.
        </div>
      ) : (
        <div className="flex-grow text-center text-sm md:text-base">
          {groupName}
          <span className="p-3 text-tdpllightgrey">|</span>
          {schools.map((item) => {
            return (
              <Chip
                key={item.schoolId}
                radius="md"
                classNames={{
                  base: 'border-small border-tdpldarkgrey bg-tdplsky border-opacity-60 m-1 p-0',
                  content: 'font-bold fit-content',
                }}
                data-testid={`selected-tank-${item.schoolId}`}
              >
                {item.tankName}
              </Chip>
            )
          })}
        </div>
      )}
    </Card>
  )
}
